/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const NotEqualUri: core.serialization.ObjectSchema<serializers.NotEqualUri.Raw, Truvity.NotEqualUri> =
    core.serialization.object({
        value: core.serialization.string(),
    });

export declare namespace NotEqualUri {
    export interface Raw {
        value: string;
    }
}
